// extracted by mini-css-extract-plugin
export var brand = "_4j-9";
export var compact = "_4j-6";
export var extraSmall = "_4j-7";
export var icon = "_4j-0";
export var large = "_4j-4";
export var light = "_4j-1";
export var medium = "_4j-5";
export var outline = "_4j-b";
export var primaryDark = "_4j-a";
export var primaryLight = "_4j-8";
export var primaryModern = "_4j-c";
export var success = "_4j-2";
export var successSolid = "_4j-3";